import React, { useState } from "react";
import { motion } from "framer-motion";
import { Song } from "../../types/song";
import { getYouTubeVideoId } from "../../utils/mediaEmbeds";
import { PlayFilledIcon } from "./PlatformIcons";

interface MusicVideoProps {
  song: Song;
}

const MusicVideo: React.FC<MusicVideoProps> = ({ song }) => {
  const [playing, setPlaying] = useState(false);
  const videoId = getYouTubeVideoId(song.youtubeVideoUrl);
  if (!videoId) return null;

  return (
    <section id="song-video" className="py-12 px-6 bg-white">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto"
      >
        <div className="text-center mb-6">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3">Music Video</h2>
          <div className="w-24 h-1 bg-purple-600 mx-auto" />
        </div>

        <div className="relative rounded-2xl overflow-hidden shadow-2xl" style={{ paddingBottom: "56.25%", height: 0 }}>
          {playing ? (
            <iframe
              title={`${song.title} music video`}
              src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full"
            />
          ) : (
            <button
              type="button"
              onClick={() => setPlaying(true)}
              aria-label={`Play ${song.title} music video`}
              className="absolute top-0 left-0 w-full h-full group cursor-pointer"
            >
              <img
                src={`https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`}
                alt={`${song.title} music video thumbnail`}
                loading="lazy"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                <div className="w-20 h-20 rounded-full bg-white/90 flex items-center justify-center shadow-2xl group-hover:scale-105 transition-transform">
                  <PlayFilledIcon className="w-8 h-8 text-purple-700 ml-1" />
                </div>
              </div>
            </button>
          )}
        </div>
      </motion.div>
    </section>
  );
};

export default MusicVideo;
